import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize, fontSize } from '@atlassian/jira-common-styles/src';
import {
	Z_INDEX,
	CARD_LIST_RADIUS,
	COLUMN_HEADER_HEIGHT,
	COLLAPSED_COLUMN_FIXED_WIDTH,
} from '../../../../common/constants';

const DRAGGING_OVER_BORDER_OFFSET = 2;
const DRAGGING_TRANSLATION_OFFSET = COLLAPSED_COLUMN_FIXED_WIDTH - DRAGGING_OVER_BORDER_OFFSET * 2;
const COLLAPSED_COLUMN_HEADER_MAX_HEIGHT =
	COLLAPSED_COLUMN_FIXED_WIDTH - DRAGGING_OVER_BORDER_OFFSET * 2;

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TextWrapper = styled.div<{
	isBold: boolean;
	isTruncated?: boolean;
	isCapitalised?: boolean;
}>(
	{
		paddingLeft: token('space.050', '4px'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		textTransform: ({ isCapitalised }) => (isCapitalised ? 'capitalise' : 'uppercase'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		fontWeight: ({ isBold }) => (isBold ? 600 : 400),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isTruncated }) =>
		isTruncated && {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
);

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderTitleWrapper = styled.div<{
	isDeletableColumn: boolean;
	isColumnCollapsed?: boolean;
	isCollapsedColumnHighlighted?: boolean;
}>(
	{
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		color: token('color.background.neutral.bold', colors.N600),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: (props: any) =>
			props.isDeletableColumn
				? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					token('color.background.danger', colors.R50)
				: token('elevation.surface.sunken', '#F4F5F7'),
		alignItems: 'center',
		justifyContent: 'left',
		display: 'flex',
		height: '100%',
		paddingLeft: token('space.200', '16px'),
		paddingRight: token('space.100', '8px'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		borderTopLeftRadius: `${CARD_LIST_RADIUS}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		borderTopRightRadius: `${CARD_LIST_RADIUS}px`,
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props: any) =>
		props.isColumnCollapsed && {
			display: 'inline-flex',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			borderRadius: `${CARD_LIST_RADIUS}px`,
			padding: `0px ${token('space.100', '8px')}`,
			border: `${DRAGGING_OVER_BORDER_OFFSET}px solid ${token(
				'elevation.surface.sunken',
				'#F4F5F7',
			)}`,
			transformOrigin: 'top left',
			transform: `translate(${
				props.isCollapsedColumnHighlighted
					? DRAGGING_TRANSLATION_OFFSET
					: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
						COLLAPSED_COLUMN_FIXED_WIDTH
			}px) rotate(90deg)`,
			maxHeight: `${COLLAPSED_COLUMN_HEADER_MAX_HEIGHT}px`,
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isCollapsedColumnHighlighted }) =>
		isCollapsedColumnHighlighted && {
			border: '0px',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			backgroundColor: token('color.background.selected.hovered', colors.B75),
		},
);

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleReadOnlyWrapper = styled.div({
	marginLeft: token('space.025', '2px'),
	flex: 1,
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleReadViewWrapper = styled.div<{
	isLoading: boolean;
	showDisabledCursor?: boolean;
	isColumnCollapsed?: boolean;
}>(
	{
		display: 'flex',
		alignItems: 'center',
		flex: 'none',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		cursor: ({ showDisabledCursor }) => (showDisabledCursor ? 'not-allowed' : 'inherit'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		padding: ({ isColumnCollapsed }) =>
			isColumnCollapsed ? `${token('space.100', '8px')} 0px` : '0px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isLoading }) =>
		isLoading && {
			'&::after': {
				content: '',
				display: 'block',
				position: 'absolute',
				height: '100%',
				top: 0,
				left: 0,
				right: 0,
				background: token('color.background.disabled', 'rgba(235, 236, 240, 0.7)'),
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				borderTopLeftRadius: `${CARD_LIST_RADIUS}px`,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				borderTopRightRadius: `${CARD_LIST_RADIUS}px`,
			},
		},
);

TitleReadViewWrapper.displayName = 'TitleReadViewWrapper';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenameClickNotAllowedWrapper = styled.div({
	width: '190px',
});

const BUTTON_SIZE = gridSize * 4;
const HEADER_PADDING = gridSize * 2;
const DRAGGED_HANDLER_SIZE = 20;

// HeaderLeftSideWrapper Width = 100% - padding - dragHandlerSize - collapseButtonSize - moreMenuButtonSize

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderLeftSideWrapper = styled.div<{ isColumnCollapsed?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ isColumnCollapsed }) =>
		isColumnCollapsed
			? 'unset'
			: `calc(100% - ${BUTTON_SIZE * 2 + HEADER_PADDING + DRAGGED_HANDLER_SIZE}px)`,
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditableColumnHeaderWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	form: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'> div': {
			marginTop: 0,
		},
		/** @see: FUN-738
		 * For keyboard focus handling; overrides extra offset when focusing on Atlaskit's InlineEdit button
		 */
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'button:focus': {
			outline: 'none',
		},
	},
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CollapseButtonWrapper = styled.div({
	flex: 'none',
	opacity: 'var(--expand-collapse-button-opacity)',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ExpandButtonWrapper = styled.div({
	transform: 'rotate(-90deg)',
	opacity: 'var(--expand-collapse-button-opacity)',
	width: 'var(--expand-button-width)',
	height: 'var(--expand-button-height)',
	marginLeft: 'var(--expand-button-margin-left)',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div<{
	isColumnCollapsed: boolean;
	isDragging?: boolean;
	isDraggable: boolean;
	isShadowVisible?: boolean;
	isCollapsedColumnHighlighted: boolean;
}>(
	{
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		zIndex: ({ isColumnCollapsed }) =>
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			isColumnCollapsed ? Z_INDEX.collapsedStickyHeaders : Z_INDEX.stickyHeaders,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		position: (props: any) => (props.isDragging ? 'relative' : 'sticky'),
		top: 0,
		userSelect: 'none',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${COLUMN_HEADER_HEIGHT}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		cursor: ({ isDraggable }) => (isDraggable ? 'grab' : 'default'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		fontSize: `${fontSize}px`,
		'&::before': {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
			opacity: (props: any) => (props.isShadowVisible ? 1 : 0),
			transition: 'opacity 0.15s',
			content: '',
			position: 'absolute',
			bottom: token('space.negative.025', '-2px'),
			left: 0,
			right: 0,
			height: '2px',
			pointerEvents: 'none',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			backgroundColor: token('color.border', colors.N30A),
		},
		'--expand-collapse-button-opacity': 0,
		'--expand-button-width': '0px',
		'--expand-button-height': '0px',
		'--expand-button-margin-left': '0px',
		'&:hover, &:focus-within': {
			'--expand-collapse-button-opacity': 1,
			'--expand-button-width': '24px',
			'--expand-button-height': '24px',
			'--expand-button-margin-left': token('space.100', '8px'),
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isCollapsedColumnHighlighted }) =>
		isCollapsedColumnHighlighted && {
			height: '100%',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			borderRadius: `${CARD_LIST_RADIUS}px`,
			border: `${DRAGGING_OVER_BORDER_OFFSET}px solid ${token(
				'color.border.selected',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				colors.B300,
			)}`,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			backgroundColor: token('color.background.selected.hovered', colors.B75),
		},
);

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TransitionInfoContainer = styled.div({
	alignItems: 'center',
	justifyContent: 'left',
	gridAutoFlow: 'column',
	display: 'grid',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& span': {
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
	},
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MenuWrapper = styled.div({
	display: 'flex',
	marginLeft: 'auto',
	minWidth: '24px',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ColumnWrapper = styled.div<{ isColumnCollapsed: boolean }>({
	display: 'flex',
	alignItems: 'center',
	'&::before': {
		content: '⠿',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		fontSize: '16px',
		lineHeight: '16px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		color: token('color.icon.subtle', colors.N500),
		minWidth: '20px',
		height: '20px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginLeft: ({ isColumnCollapsed }) =>
		isColumnCollapsed ? '0px' : token('space.negative.150', '-12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ isColumnCollapsed }) => (isColumnCollapsed ? '100%' : 'calc(100% + 12px)'),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Image = styled.img({
	width: token('space.200', '16px'),
	height: token('space.200', '16px'),
	verticalAlign: 'text-bottom',
});
